export abstract class FetchCourseQuery {
  abstract exec(props: FetchCourseQuery.Props): Promise<any>;
}

export namespace FetchCourseQuery {
  export type Props = {
    courseId: string;
  };
}
